"use client";

import { useState } from "react";

export function EnquiryForm({ trainingSlug }: { trainingSlug?: string }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    company: "",
    phone: "",
    subject: trainingSlug ? "booking" : "general",
    message: trainingSlug ? `Enquiry about training: ${trainingSlug}` : "",
  });
  const [status, setStatus] = useState<"idle" | "sending" | "sent" | "error">("idle");

  const handleSubmit = async () => {
    setStatus("sending");
    try {
      const res = await fetch("/api/enquiry", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (res.ok) setStatus("sent");
      else setStatus("error");
    } catch {
      setStatus("error");
    }
  };

  if (status === "sent") {
    return (
      <div className="bg-sh-panel rounded-lg p-8 text-center">
        <p className="font-serif text-lg text-sh-tx mb-2">Thank you</p>
        <p className="font-sans text-sm text-sh-tx2">We will be in touch within 24 hours.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4 max-w-lg">
      <div className="grid grid-cols-2 gap-4">
        <Field label="Name" value={form.name} onChange={(v) => setForm({ ...form, name: v })} required />
        <Field label="Email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} type="email" required />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <Field label="Company" value={form.company} onChange={(v) => setForm({ ...form, company: v })} />
        <Field label="Phone" value={form.phone} onChange={(v) => setForm({ ...form, phone: v })} />
      </div>
      <div>
        <label className="font-sans text-[11px] font-medium text-sh-tx2 block mb-1.5">Subject</label>
        <select
          value={form.subject}
          onChange={(e) => setForm({ ...form, subject: e.target.value })}
          className="w-full px-3.5 py-2.5 border border-black/[0.06] rounded-lg font-sans text-[13px] text-sh-tx bg-sh-bg outline-none"
        >
          <option value="booking">Training Booking</option>
          <option value="in_company">In-company Programme</option>
          <option value="platform">Platform Access</option>
          <option value="general">General Enquiry</option>
        </select>
      </div>
      <div>
        <label className="font-sans text-[11px] font-medium text-sh-tx2 block mb-1.5">Message</label>
        <textarea
          value={form.message}
          onChange={(e) => setForm({ ...form, message: e.target.value })}
          rows={4}
          className="w-full px-3.5 py-2.5 border border-black/[0.06] rounded-lg font-sans text-[13px] text-sh-tx bg-sh-bg outline-none resize-none"
        />
      </div>
      {status === "error" && (
        <p className="font-sans text-xs text-sh-red">Something went wrong. Please try again or email us directly.</p>
      )}
      <button
        onClick={handleSubmit}
        disabled={status === "sending" || !form.name || !form.email || !form.message}
        className="font-sans text-[13px] font-semibold bg-sh-tx text-white border-none py-3 px-7 rounded-3xl cursor-pointer disabled:opacity-50"
      >
        {status === "sending" ? "Sending..." : "Send enquiry"}
      </button>
    </div>
  );
}

function Field({
  label,
  value,
  onChange,
  type = "text",
  required = false,
}: {
  label: string;
  value: string;
  onChange: (v: string) => void;
  type?: string;
  required?: boolean;
}) {
  return (
    <div>
      <label className="font-sans text-[11px] font-medium text-sh-tx2 block mb-1.5">
        {label}{required && " *"}
      </label>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-3.5 py-2.5 border border-black/[0.06] rounded-lg font-sans text-[13px] text-sh-tx bg-sh-bg outline-none"
      />
    </div>
  );
}
